module.exports = __webpack_public_path__ + "img/activesection.ae556d47.svg";